import { CasinoGame } from '@/backend/casino/get-casino-category-games/types';
import { Provider } from '@/backend/casino/get-casino-provider-list/types';
import { CasinoCategory } from '@/backend/casino/get-categories/types';
import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

/* -------------------------------------------------------------------------- */

interface AppStore {
	casinoGamesWithCategories: any[] | null;
	providers: Provider[] | null;
	categories: CasinoCategory[] | [];

	actions: {
		setCasinoGamesWithCategories: (casinoGames: CasinoGame[]) => void;
		setProviders: (providers: Provider[]) => void;
		setCategories: (categories: CasinoCategory[]) => void;
	};
}

const appStore = create<AppStore>((set) => ({
	casinoGamesWithCategories: [],
	providers: [],
	categories: [],

	/* -------------------------------------------------------------------------- */

	actions: {
		setCasinoGamesWithCategories: (casinoGames: CasinoGame[]) => {
			set(() => ({
				casinoGamesWithCategories: casinoGames,
			}));
		},
		setProviders: (providers: Provider[]) => {
			set(() => ({
				providers,
			}));
		},
		setCategories: (categories: CasinoCategory[]) => {
			set(() => ({
				categories,
			}));
		},
	},
}));

export const useCasinoStoreActions = () => appStore((state) => state.actions);

export const useCasinoGamesWithCategories = () =>
	appStore(useShallow((state) => state.casinoGamesWithCategories));

export const useProviders = () =>
	appStore(useShallow((state) => state.providers));

export const useCategories = () =>
	appStore(useShallow((state) => state.categories));
